if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.bf-before-after__range');
        if (!this.range || this.initialized) return;

        this.initialized = true;
        this.updatePosition = this.updatePosition.bind(this);
        this.range.addEventListener('input', this.updatePosition);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.updatePosition);
      }

      updatePosition() {
        this.style.setProperty('--bf-ba-position', `${this.range.value}%`);
      }
    }
  );
}
